var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "orderList" },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm.flag
        ? _c(
            "div",
            [
              _vm._l(_vm.orderList, function(item, index) {
                return _c("div", { key: index, staticClass: "content" }, [
                  _c("div", { staticClass: "top" }, [
                    _c("div", { staticClass: "left" }, [
                      _c(
                        "span",
                        {
                          staticClass: "shopName",
                          on: {
                            click: function($event) {
                              return _vm.toStore(item.shopId)
                            }
                          }
                        },
                        [
                          item.shopLogo
                            ? _c("img", {
                                attrs: { src: item.shopLogo, alt: "" }
                              })
                            : _c("img", {
                                attrs: {
                                  src: require("../../assets/images/logo.png"),
                                  alt: ""
                                }
                              }),
                          _vm._v(
                            "\n            " +
                              _vm._s(item.shopName) +
                              "\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "time" }, [
                        _vm._v(_vm._s(item.createTime))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "orderCode" }, [
                        _vm._v("订单号：" + _vm._s(item.orderFormid))
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          "支付方式：" +
                            _vm._s(
                              _vm._f("paymentModeFormat")(item.paymentMode)
                            )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "right",
                        staticStyle: {
                          "justify-content": "space-between",
                          "padding-right": "15px"
                        }
                      },
                      [
                        _c(
                          "div",
                          [
                            _c("el-tag", [
                              _vm._v(
                                _vm._s(item.category == 1 ? "大宗" : "零售")
                              )
                            ]),
                            _vm._v(" "),
                            item.dropShip == 1
                              ? _c(
                                  "el-tag",
                                  { staticStyle: { "margin-left": "10px" } },
                                  [_vm._v("云仓代发")]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "cur-poi",
                          attrs: {
                            src: require("../../../static/image/shanchu@2x.png"),
                            alt: ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.$emit("isDelete", item.orderId)
                            }
                          }
                        })
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "productBox" }, [
                    _c("div", { staticClass: "product" }, [
                      _c(
                        "div",
                        { staticClass: "left fs13" },
                        _vm._l(item.skus, function(items, indexs) {
                          return _c(
                            "div",
                            { key: indexs, staticClass: "box" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "desc cur-poi",
                                  on: {
                                    click: function($event) {
                                      return _vm.toProductDetail(
                                        item.shopId,
                                        items
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("img", {
                                    attrs: { src: items.image, alt: "" }
                                  }),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c("p", { staticClass: "name" }, [
                                      _vm._v(_vm._s(items.productName))
                                    ])
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "price" },
                                _vm._l(items.values, function(val, idx) {
                                  return _c("span", { key: idx }, [
                                    _vm._v(_vm._s(val))
                                  ])
                                }),
                                0
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "price" }, [
                                _c("span", [_vm._v("¥" + _vm._s(items.price))]),
                                _vm._v(" "),
                                items.originalPrice &&
                                items.originalPrice != items.price
                                  ? _c(
                                      "del",
                                      { staticStyle: { color: "#999" } },
                                      [
                                        _vm._v(
                                          "¥" + _vm._s(items.originalPrice)
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "num" }, [
                                _c("p", { staticClass: "fs14" }, [
                                  _vm._v("x " + _vm._s(items.checkNumber))
                                ]),
                                _vm._v(" "),
                                _vm.isSchool
                                  ? _c(
                                      "del",
                                      {
                                        staticClass: "fs14 fsdel",
                                        staticStyle: {
                                          color: "#999",
                                          "font-size": "12px"
                                        }
                                      },
                                      [_vm._v("x " + _vm._s(items.number))]
                                    )
                                  : _vm._e()
                              ])
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "right",
                          class: item.skus.length > 1 ? "right_line" : ""
                        },
                        [
                          _c("div", { staticClass: "consignee" }, [
                            _vm._v(_vm._s(item.receiveName))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "actualPay" }, [
                            !_vm.isSchool
                              ? _c("div", [
                                  _c("p", { staticClass: "fs13 mar-bot-5" }, [
                                    _vm._v(
                                      "\n                  ¥" +
                                        _vm._s(
                                          (
                                            item.orderPrice - item.discountPrice
                                          ).toFixed(2)
                                        ) +
                                        "\n                "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  item.originalPrice != 0
                                    ? _c(
                                        "p",
                                        {
                                          staticClass: "fs13 mar-bot-5",
                                          staticStyle: {
                                            "text-decoration": "line-through",
                                            color: "#999"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  ¥" +
                                              _vm._s(
                                                (
                                                  item.originalPrice -
                                                  item.discountPrice
                                                ).toFixed(2)
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "fs13" }, [
                                    _vm._v(
                                      "(含运费：¥" +
                                        _vm._s(item.logisticsPrice) +
                                        ")"
                                    )
                                  ])
                                ])
                              : _c("div", [
                                  _c("p", { staticClass: "fs13 mar-bot-5" }, [
                                    _vm._v(
                                      "\n                  ¥" +
                                        _vm._s(
                                          (
                                            item.checkPrice - item.discountPrice
                                          ).toFixed(2)
                                        ) +
                                        "\n                "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass: "fs13 mar-bot-5",
                                      staticStyle: { color: "#999" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  首次支付金额: ¥" +
                                          _vm._s(
                                            (
                                              item.orderPrice -
                                              item.discountPrice
                                            ).toFixed(2)
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  item.checkPrice - item.orderPrice > 0 &&
                                  item.state == 4
                                    ? _c(
                                        "p",
                                        { staticClass: "fs13 mar-bot-5" },
                                        [
                                          _vm._v(
                                            "\n                  已追加支付金额:\n                  "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: { color: "#ff4747" }
                                            },
                                            [
                                              _vm._v(
                                                "¥" +
                                                  _vm._s(
                                                    (
                                                      item.checkPrice -
                                                      item.orderPrice
                                                    ).toFixed(2)
                                                  )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.checkPrice - item.orderPrice < 0 &&
                                  item.state == 4
                                    ? _c(
                                        "p",
                                        { staticClass: "fs13 mar-bot-5" },
                                        [
                                          _vm._v(
                                            "\n                  已退款金额:\n                  "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: { color: "#ff4747" }
                                            },
                                            [
                                              _vm._v(
                                                "¥" +
                                                  _vm._s(
                                                    (
                                                      item.orderPrice -
                                                      item.checkPrice
                                                    ).toFixed(2)
                                                  )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.originalPrice != 0
                                    ? _c(
                                        "p",
                                        {
                                          staticClass: "fs13 mar-bot-5",
                                          staticStyle: {
                                            "text-decoration": "line-through",
                                            color: "#999"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  ¥" +
                                              _vm._s(
                                                (
                                                  item.originalPrice -
                                                  item.discountPrice
                                                ).toFixed(2)
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "fs13" }, [
                                    _vm._v(
                                      "(含运费：¥" +
                                        _vm._s(item.logisticsPrice) +
                                        ")"
                                    )
                                  ])
                                ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "status" }, [
                            _c("div", [
                              item.state == 1
                                ? _c(
                                    "p",
                                    {
                                      staticClass:
                                        "fs13 mar-bot-5 font-color-FF7"
                                    },
                                    [
                                      _vm._v(
                                        "\n                  待付款\n                "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.state == 2
                                ? _c(
                                    "p",
                                    {
                                      staticClass:
                                        "fs13 mar-bot-5 font-color-FF7"
                                    },
                                    [
                                      _vm._v(
                                        "\n                  待发货\n                "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.state == 3
                                ? _c(
                                    "p",
                                    {
                                      staticClass:
                                        "fs13 mar-bot-5 font-color-FF7"
                                    },
                                    [
                                      _vm._v(
                                        "\n                  待收货\n                "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.state == 4
                                ? _c(
                                    "p",
                                    {
                                      staticClass:
                                        "fs13 mar-bot-5 font-color-71B"
                                    },
                                    [
                                      _vm._v(
                                        "\n                  已完成\n                "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.state == 5
                                ? _c(
                                    "p",
                                    {
                                      staticClass:
                                        "fs13 mar-bot-5 font-color-999"
                                    },
                                    [
                                      _vm._v(
                                        "\n                  已关闭\n                "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.state == 6
                                ? _c(
                                    "p",
                                    {
                                      staticClass:
                                        "fs13 mar-bot-5 font-color-FF7"
                                    },
                                    [
                                      _vm._v(
                                        "\n                  待成团\n                "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "operate" }, [
                            _c(
                              "div",
                              [
                                item.state == 1 ||
                                (item.paymentState == 0 && item.state == 6)
                                  ? _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "throttle",
                                            rawName: "v-throttle"
                                          }
                                        ],
                                        staticClass: "fs13 mar-bot-5",
                                        attrs: {
                                          type: "primary",
                                          size: "small",
                                          disabled: item.orderFrom == 1
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.getUrl(item)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              item.orderFrom == 1
                                                ? "待卖家收款"
                                                : "去付款"
                                            )
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                item.state == 2 && item.orderFrom != 1
                                  ? _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "throttle",
                                            rawName: "v-throttle"
                                          }
                                        ],
                                        staticClass: "fs13 mar-bot-5",
                                        attrs: {
                                          type: "primary",
                                          size: "small"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.remind(item.orderId)
                                          }
                                        }
                                      },
                                      [_vm._v("提醒发货\n                ")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                item.state == 3 &&
                                item.ifAfter == 1 &&
                                item.orderFrom != 1
                                  ? _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "throttle",
                                            rawName: "v-throttle"
                                          }
                                        ],
                                        staticClass: "fs13 mar-bot-5",
                                        attrs: {
                                          type: "primary",
                                          size: "small"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.$emit(
                                              "isConfirm",
                                              item.orderId,
                                              item
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("确认收货")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                (item.state == 4 || item.state == 5) &&
                                item.orderFrom != 1
                                  ? _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "throttle",
                                            rawName: "v-throttle"
                                          }
                                        ],
                                        staticClass: "fs13 mar-bot-5",
                                        attrs: {
                                          type: "primary",
                                          size: "small",
                                          disabled:
                                            item.shopDiscountId != 0 ||
                                            item.shopGroupWorkId != 0 ||
                                            item.shopSeckillId != 0
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.buyAgain(item.orderId)
                                          }
                                        }
                                      },
                                      [_vm._v("\n                  再次购买")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                (item.state == 1 || item.state == 6) &&
                                item.orderFrom != 1
                                  ? _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "throttle",
                                            rawName: "v-throttle"
                                          }
                                        ],
                                        staticClass: "fs13 cur-poi",
                                        attrs: { size: "small" },
                                        on: {
                                          click: function($event) {
                                            return _vm.$emit(
                                              "isCancel",
                                              item.orderId
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("取消订单")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                item.state == 4 &&
                                item.ifNotComment === 1 &&
                                item.orderFrom != 1
                                  ? _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "throttle",
                                            rawName: "v-throttle"
                                          }
                                        ],
                                        staticClass: "fs13 cur-poi",
                                        attrs: { size: "small" },
                                        on: {
                                          click: function($event) {
                                            return _vm.toEvaluate(item)
                                          }
                                        }
                                      },
                                      [_vm._v("评价")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                item.state == 3 && item.orderFrom != 1
                                  ? _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "throttle",
                                            rawName: "v-throttle"
                                          }
                                        ],
                                        staticClass: "fs13 cur-poi",
                                        attrs: { size: "small" },
                                        on: {
                                          click: function($event) {
                                            return _vm.toOrderDetail(
                                              item.orderId
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("查看物流")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "throttle",
                                        rawName: "v-throttle"
                                      }
                                    ],
                                    staticClass: "fs13 mar-bot-5 detail",
                                    attrs: { size: "small" },
                                    on: {
                                      click: function($event) {
                                        return _vm.toOrderDetail(
                                          item.orderId,
                                          item
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("订单详情")]
                                )
                              ],
                              1
                            )
                          ])
                        ]
                      )
                    ])
                  ])
                ])
              }),
              _vm._v(" "),
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.page,
                  "page-size": 5,
                  background: "",
                  layout: "prev, pager, next",
                  total: _vm.total
                },
                on: { "current-change": _vm.handleCurrentChange }
              })
            ],
            2
          )
        : _c(
            "div",
            { staticClass: "noorder" },
            [
              _c("img", {
                attrs: {
                  src: require("../../../static/image/noorder@2x.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("p", { staticClass: "fs20 font-color-999" }, [
                _vm._v("您还没有订单哦～")
              ]),
              _vm._v(" "),
              _c(
                "router-link",
                { attrs: { to: "/" } },
                [_c("el-button", [_vm._v("去首页看看")])],
                1
              )
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "weChat",
          attrs: {
            visible: _vm.weChatDialog,
            "before-close": _vm.handleClose,
            width: "25%"
          },
          on: {
            "update:visible": function($event) {
              _vm.weChatDialog = $event
            }
          }
        },
        [
          _c("div", { staticClass: "weChatBox" }, [
            _c(
              "div",
              {
                staticStyle: {
                  "font-size": "18px",
                  color: "#000000",
                  padding: "0 20px"
                }
              },
              [
                _vm._v(
                  "\n        请使用具有扫码支付功能的APP完成支付（支持微信、支付宝、云闪付等APP）\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "font-size": "32px",
                  color: "#000000",
                  width: "100%",
                  "text-align": "center"
                }
              },
              [_vm._v("\n        ￥" + _vm._s(_vm.payInfo.money) + "\n      ")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "qCode" }, [
              _c("img", {
                attrs: {
                  src: "data:image/jpeg;base64," + _vm.payInfo.c2bQrCodeBase64,
                  width: "100%",
                  height: "100%",
                  alt: ""
                }
              })
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "head" }, [
      _c("div", { staticStyle: { flex: "9", "padding-left": "20px" } }, [
        _c("span", { staticStyle: { flex: "3" } }, [_vm._v("商品名称")]),
        _vm._v(" "),
        _c("span", { staticStyle: { flex: "2" } }, [_vm._v("商品属性")]),
        _vm._v(" "),
        _c("span", { staticStyle: { flex: "2" } }, [_vm._v("单价")]),
        _vm._v(" "),
        _c("span", { staticStyle: { flex: "2" } }, [_vm._v("数量")])
      ]),
      _vm._v(" "),
      _c("div", { staticStyle: { flex: "9", "padding-right": "20px" } }, [
        _c("span", { staticStyle: { flex: "1" } }, [_vm._v("收货人")]),
        _vm._v(" "),
        _c("span", { staticStyle: { flex: "2" } }, [_vm._v("实付款")]),
        _vm._v(" "),
        _c("span", { staticStyle: { flex: "2" } }, [_vm._v("状态")]),
        _vm._v(" "),
        _c("span", { staticStyle: { flex: "4", "text-align": "left" } }, [
          _vm._v("操作")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-6bf9eb44", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-6bf9eb44","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/base/orderList.vue
// module id = null
// module chunks = 